export default "__VITE_ASSET__CsF8Ogjo__"